/**
 * Every move that waits a few seconds with an Undo before it's sent (waitForUndo), and when: the one place to look
 * when changing which moves can be taken back. A move waits because it can't be undone once the game has it, and
 * it's easy to make by mistake.
 *
 * Each returns the words the Undo shows as its title ("Retreating"), or null when the move goes at once.
 */

/** Retreating: always. It costs energy and a turn's retreat, and a drag can land on the wrong Pokémon. */
export const retreatWaits = () => 'Retreating';

/** Trainers, by name, that wait (Switch trades your active Pokémon, like a retreat). */
const TRAINERS = { Switch: 'Switching' };
export const trainerWaits = (trainerName) => TRAINERS[trainerName] || null;

/**
 * Attaching energy: only when it was dragged there, which is easy to drop on the wrong Pokémon. Tapping a Pokémon
 * to attach to (or "Attach to X") is a choice made on purpose.
 */
export const attachWaits = ({ dragged }) => (dragged ? 'Attaching' : null);
